<div class="dialog-container">
  <div class="dialog-header">
    <h2>Novo Usuário</h2>
    <button mat-icon-button [mat-dialog-close]="null" class="close-button" matTooltip="Fechar diálogo">
      <mat-icon matTooltip="Fechar diálogo">close</mat-icon>
    </button>

  </div>
  <div class="dialog-content">
    <!--    {{ usuarioForm.value | json }}-->
    <form [formGroup]="usuarioForm">
      <div class="row g-2">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Login</mat-label>
            <input matInput formControlName="dscLogin" maxlength="50" required />
            <mat-error *ngIf="usuarioForm.get('dscLogin')?.hasError('required')">Obrigatório</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row g-2">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nome</mat-label>
            <input matInput formControlName="dscNome" maxlength="100" required />
            <mat-error *ngIf="usuarioForm.get('dscNome')?.hasError('required')">Obrigatório</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row g-2">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Email</mat-label>
            <input matInput formControlName="dscEmail" placeholder="ex. email@empresa.com.br" maxlength="100"
              required />
            <mat-error *ngIf="usuarioForm.get('dscEmail')?.hasError('required')">Obrigatório</mat-error>
            <mat-error *ngIf="usuarioForm.get('dscEmail')?.hasError('dscEmail')">E-mail inválido</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row g-2">
        <div class="col-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>DDD</mat-label>
            <input matInput formControlName="numDddFone" maxlength="2" />
            <mat-error *ngIf="usuarioForm.get('numDddFone')?.hasError('required')">Obrigatório</mat-error>
            <mat-error *ngIf="usuarioForm.get('numDddFone')?.hasError('pattern')">DDD inválido</mat-error>
          </mat-form-field>
        </div>
        <div class="col-8">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Telefone</mat-label>
            <input matInput formControlName="numFone" mask="00000-0000" placeholder="ex. 91234-5678" maxlength="9" />
            <mat-error *ngIf="usuarioForm.get('numFone')?.hasError('required')">Obrigatório</mat-error>
            <mat-error *ngIf="usuarioForm.get('numFone')?.hasError('pattern')">Telefone inválido</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row g-2">
        <div class="col gap-2 d-flex justify-content-end">
          <button mat-flat-button color="accent" (click)="onConfirmar()" type="submit"
            [disabled]="loading || !usuarioForm.valid">
            <mat-icon>check</mat-icon>
            Confirmar
          </button>
          <button mat-flat-button type="button" (click)="onCancelar()" [disabled]="loading">
            <mat-icon>close</mat-icon>
            Cancelar
          </button>
        </div>
      </div>
    </form>
  </div>

</div>